export default {
    'ad': 'Reklama',
    'place-for-your-ad': 'Miejsce na Twoją reklamę'
}
